<template>
  <el-dialog
    title="分配记录"
    :visible.sync="visible"
    width="700px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-table
      v-loading="loading"
      :data="list">
      <el-table-column
        label="机构名称"
        prop="sgsName"> </el-table-column>
      <el-table-column
        label="开始标签序号"
        prop="beginTagNo">
      </el-table-column>
      <el-table-column
        label="结束标签序号"
        prop="endTagNo"> </el-table-column>
      <el-table-column
        label="标签数量"
        prop="tagCount"> </el-table-column>
      <el-table-column
        label="已使用数量"
        prop="usedTagCount">
      </el-table-column>
      <el-table-column
        label="分配时间"
        width="140">
        <template slot-scope="{ row }">
          <span>{{ row.createdTime | dateformat() }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ListModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.totalNum = 0
      this.config.pageNum = 1
      this.list = []
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/gettagassigns', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    init(options) {
      this.config = {
        ...this.config,
        ...options
      }
      this.toggleModal(true)
      this.getlist()
    }
  }
}
</script>
